import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { Auth } from '../../services/auth/auth';
import { OrganizationSwitcher } from '../organization-switcher/organization-switcher';

@Component({
  selector: 'app-header',
  imports: [
    RouterLink,
    RouterLinkActive,
    LucideAngularModule,
    NgOptimizedImage,
    OrganizationSwitcher,
  ],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Header {
  protected readonly auth = inject(Auth);
  protected readonly dropdownOpen = signal(false);
  protected readonly mobileAuthMenuOpen = signal(false);
  protected readonly runsMenuOpen = signal(false);
  private readonly router = inject(Router);

  toggleMobileAuthMenu(): void {
    this.mobileAuthMenuOpen.update((value) => !value);
  }

  closeMobileAuthMenu(): void {
    this.mobileAuthMenuOpen.set(false);
  }

  toggleDropdown(): void {
    this.dropdownOpen.update((v) => !v);
  }

  closeDropdown(): void {
    this.dropdownOpen.set(false);
  }

  toggleRunsMenu(): void {
    this.runsMenuOpen.update((v) => !v);
  }

  closeRunsMenu(): void {
    this.runsMenuOpen.set(false);
  }

  signIn(): void {
    this.closeMobileAuthMenu();
    this.auth.signIn();
  }

  signUp(): void {
    this.closeMobileAuthMenu();
    this.auth.signUp();
  }

  async signOut(): Promise<void> {
    this.closeDropdown();
    await this.auth.signOut();
    await this.router.navigate(['/']);
  }

  openProfile(): void {
    this.auth.openUserProfile();
    this.closeDropdown();
  }
}
